module.exports = __webpack_public_path__ + "static/media/vietnam-icon.b4815b50.svg";